import { ApiAdapter } from '@unmapped/core/state/ApiAdapter';
import startCase from 'lodash/startCase';
export const PropertyListingAdapter = new ApiAdapter();
PropertyListingAdapter.handleRequest(async h => {
  return window.__AY_MAPS_DATA__;
}).resolveResults('results').location.resolveId('id').resolveName('title').resolve('__kind', () => 'propertyListing').resolveLatLng({
  lat: 'location.lat',
  lng: 'location.lng'
}).resolve('displayAddress', result => {
  const lines = [];
  if (result.location.address) lines.push(startCase(result.location.address));
  if (result.location.address2) lines.push(startCase(result.location.address2));
  let lastLine = '';
  if (result.location.city) {
    lastLine += startCase(result.location.city);
    if (result.location.state || result.location.zip) {
      lastLine += ', ';
    }
  }
  if (result.location.state) lastLine += startCase(result.location.state);
  if (result.location.zip) lastLine += ` ${result.location.zip}`;
  lines.push(lastLine);
  return lines.filter(line => !!line);
});
export default PropertyListingAdapter;